import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      {/* الجزء العلوي */}
      <div className="footer-top">
        <div className="footer-logo">
          <img
            src="https://res.cloudinary.com/defcamc5x/image/upload/v1760316286/jyjo3ggcopteihukwoau.png"
            alt="شعار المؤسسة"
          />
          <h3>المؤسسة الدولية للاستدامة والتنمية</h3>
          <p>معًا نحو مستقبل أكثر استدامة وعدالة</p>
        </div>

        <div className="footer-links">
          <h4>روابط سريعة</h4>
          <ul>
            <li><a href="/">الرئيسية</a></li>
            <li><a href="/about">من نحن</a></li>
            <li><a href="/projects">مشروعاتنا</a></li>
            <li><a href="/contact">تواصل معنا</a></li>
          </ul>
        </div>

        <div className="footer-contact">
          <h4>تواصل معنا</h4>
          <p>              📍 ش سوتر - امام بوابة كلية الحقوق - الاسكندرية
</p>
          <p>📞 01234567890</p>
          <p>✉️ info@iisd-eg.org</p>

          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f"></i></a>
            <a href="#"><i className="fab fa-twitter"></i></a>
            <a href="#"><i className="fab fa-instagram"></i></a>
            <a href="#"><i className="fab fa-linkedin-in"></i></a>
          </div>
        </div>
      </div>

      {/* الخط الفاصل */}
      <div className="footer-divider"></div>

      {/* الجزء السفلي */}
      <div className="footer-bottom">
        <p>© 2025 جميع الحقوق محفوظة للمؤسسة الدولية للاستدامة والتنمية</p>
        <p>تصميم وتنفيذ <span>Horizonya</span></p>
      </div>

      <style>{`
        .footer {
          background: linear-gradient(135deg, #002a6d, #004aad);
          color: #fff;
          padding: 60px 20px 30px;
          direction: rtl;
          font-family: "Cairo", sans-serif;
        }

        .footer-top {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-start;
          gap: 40px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .footer-logo {
          flex: 1.2;
          text-align: right;
        }

        .footer-logo img {
          width: 90px;
          margin-bottom: 15px;
          filter: drop-shadow(0 3px 6px rgba(0,0,0,0.3));
        }

        .footer-logo h3 {
          color: #b08b56;
          font-size: 1.5rem;
          margin-bottom: 8px;
        }

        .footer-logo p {
          color: #e5e5e5;
          font-size: 1rem;
          line-height: 1.8;
        }

        .footer-links, .footer-contact {
          flex: 1;
          min-width: 250px;
        }

        .footer-links h4, .footer-contact h4 {
          color: #b08b56;
          font-size: 1.3rem;
          margin-bottom: 15px;
          position: relative;
        }

        .footer-links h4::after, .footer-contact h4::after {
          content: "";
          position: absolute;
          bottom: -6px;
          right: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(90deg, #b08b56, #ffffff);
          border-radius: 2px;
        }

        .footer-links ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 10px;
        }

        .footer-links a {
          color: #f5f5f5;
          text-decoration: none;
          font-size: 1rem;
          transition: color 0.3s ease;
        }

        .footer-links a:hover {
          color: #b08b56;
        }

        .footer-contact p {
          font-size: 1rem;
          color: #eaeaea;
          margin-bottom: 8px;
        }

        .social-icons {
          margin-top: 12px;
        }

        .social-icons a {
          color: #fff;
          font-size: 1.2rem;
          margin-left: 10px;
          transition: color 0.3s ease, transform 0.3s ease;
        }

        .social-icons a:hover {
          color: #b08b56;
          transform: translateY(-3px);
        }

        .footer-divider {
          height: 1px;
          background: rgba(255, 255, 255, 0.2);
          margin: 30px auto;
          width: 85%;
        }

        .footer-bottom {
          text-align: center;
          font-size: 0.95rem;
          color: #ddd;
        }

        .footer-bottom span {
          color: #b08b56;
          font-weight: 600;
        }

        /* ريسبونسيف */
        @media (max-width: 768px) {
          .footer-top {
            flex-direction: column;
            text-align: center;
          }

          .footer-logo, .footer-links, .footer-contact {
            text-align: center;
          }

          .footer-links h4::after, .footer-contact h4::after {
            right: 50%;
            transform: translateX(50%);
          }

          .social-icons a {
            margin: 0 8px;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
